import {
    Card, Grid, Typography
} from "@mui/material";
import { generateReportAuthorityListPDFApi, getReportAuthorityListApi } from 'api/report';
import ReportAuthorityListFilterCard from "app/components/Card/report/ReportAuthorityListFilterCard";
import ReportAuthorityListTable from "app/components/Table/reports/ReportAuthorityListTable";
import React, { useState } from "react";

const ReportAuthorityListPage = () => {
    const [data, setData] = useState([]);
    const [lastFilter, setLastFilter] = useState(null);
    const [hasSearched, setHasSearched] = useState(false);

    const setFilterData = (data) => {
        setData(data);
    };

    const groupedData = data.reduce((groups, item) => {
        const roleId = item.roleId;
        if (!groups[roleId]) {
            groups[roleId] = {
                roleName: item.roleName,
                members: []
            };
        }
        groups[roleId].members.push(item);
        return groups;
    }, {});

    const handleResultListAuthority = async (filters) => {
        setHasSearched(true);
        try {
            const res = await getReportAuthorityListApi(filters);
            const responseData = res.data?.data || res.data || [];
            setFilterData(responseData);
            setLastFilter(filters);
        } catch (err) {
            console.error(err);
        }
    };

    const generateAuthorityPDF = async () => {
        if (!lastFilter) return;
        try {
            await generateReportAuthorityListPDFApi(lastFilter);
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <React.Fragment>
            <Grid container sx={{ marginBottom: 4 }}>
                <Grid item xs={12} md={12}>
                    <ReportAuthorityListFilterCard
                        title="Kurul/Kol/Komisyon Üye Listesi"
                        setFilterData={setFilterData}
                        handleResultList={handleResultListAuthority}
                        generatePDFApi={generateAuthorityPDF}
                    />
                </Grid>
            </Grid>

            {hasSearched && (
                <Card sx={{ padding: 2 }}>
                    {data.length > 0 ? (
                        <ReportAuthorityListTable data={groupedData} />
                    ) : (
                        <Typography
                            variant="h6"
                            sx={{
                                textAlign: 'center',
                                color: 'text.secondary',
                                padding: 3
                            }}
                        >
                            Sonuç bulunamadı
                        </Typography>
                    )}
                </Card>
            )}
        </React.Fragment>
    );
};

export default ReportAuthorityListPage; 